/** @format */

import {AccountDesignsOrdersContext} from 'frontier/account/components/context/AccountDesignsOrdersContext';
import SingleDesignPreview from '../../../shared/single_design_preview';
import React, {useContext, useState} from 'react';
import update from 'immutability-helper';

// styles
import './artwork_column.scss';

const ColumnContainer = props => {
    const {isShowingThumbnails} = props;
    const ctx = useContext(AccountDesignsOrdersContext);

    return (
        <div className="artwork-column-27ux">
            <div className="artwork-column-27ux__table-cell">
                <SingleDesignPreview showThumbnails={isShowingThumbnails} scrollModalToEvent>
                    <button
                        className="artwork-column-27ux__button color-accent-primary
                                d-flex align-items-center justify-content-start
                                p-0">
                        <i className="fa fa-eye" />
                        <u>View Full Size</u>
                    </button>
                </SingleDesignPreview>
                <p className="color-accent-primary">
                    <span>{ctx.designs_order.filename_without_id}</span>
                </p>
                <p className="artwork-column-27ux__design-id color-structure-darker">
                    <span>
                        <b>Artwork ID:</b> {ctx.design.id}
                    </span>
                </p>
            </div>
        </div>
    );
};

export const ArtworkColumn = props => {
    const {designOrder, ...resOfProps} = props;
    const order = designOrder.order;

    const [design, setDesign] = useState(designOrder.design);

    const handleToggleIsArchived = value => {
        const updateTarget = {
            is_archived: {$set: value}
        };
        setDesign(update(design, updateTarget));
    };

    const contextValue = {
        designs_order: designOrder,
        handleToggleIsArchived,
        size: order.size,
        design,
        order
    };

    return (
        <AccountDesignsOrdersContext.Provider value={contextValue}>
            <ColumnContainer {...resOfProps} />
        </AccountDesignsOrdersContext.Provider>
    );
};
